import { Spread } from 'braid-design-system';

const CTASectionView = ({
  textContent,
  buttonsContent,
}: {
  textContent?: React.JSX.Element;
  buttonsContent?: React.JSX.Element;
}) => (
  <Spread space="gutter" alignY="bottom">
    {textContent}
    {buttonsContent}
  </Spread>
);

export default CTASectionView;
